import { CollectionHelper } from 'src/app/helpers/collection-helper';
import Asset from 'src/app/model/asset';
import { ImmoTask } from 'src/app/model/immo-task/immo-task';
import { IMMO_TASK_ASSET_TYPE_CHOICES } from 'src/app/model/immo-task/immo-task-asset-type';
import { ImmoIPImmoTaskChangesObject } from 'src/app/services/immo-ip-placer-offline-changes/immo-ip-immo-task-changes/immo-ip-immo-task-changes-object';
import { ImmoIPImmoTaskChangesService } from 'src/app/services/immo-ip-placer-offline-changes/immo-ip-immo-task-changes/immo-ip-immo-task-changes.service';
import { SnackService } from 'src/app/services/snack.service';
import { ImmoIPPlacerImmoTaskChangeStorageHandler } from './immo-ip-placer-immo-task-change-storage-handler';
import { clone } from 'lodash';
import { ImmoIPImmoTaskSubmitService } from 'src/app/services/immo-ip-immo-task-submit/immo-ip-immo-task-submit.service';

export class ImmoIPPlacerImmoTaskChangeStorageHandlerHelper {
  private constructor() {}

  public static async initializeImmoIPPlacerImmoTaskChangeStorageHandler(
    immoTask: ImmoTask,
    dateString: string,
    immoIPImmoTaskChangesService: ImmoIPImmoTaskChangesService,
    immoIPImmoTaskSubmitService: ImmoIPImmoTaskSubmitService,
    snackService: SnackService
  ) {
    let immoTaskChanges = await this.initializeImmoTaskChanges(
      immoTask,
      immoIPImmoTaskChangesService
    );
    return new ImmoIPPlacerImmoTaskChangeStorageHandler(
      dateString,
      immoTaskChanges,
      immoIPImmoTaskChangesService,
      immoIPImmoTaskSubmitService,
      snackService
    );
  }

  private static async initializeImmoTaskChanges(
    immoTask: ImmoTask,
    immoIPImmoTaskChangesService: ImmoIPImmoTaskChangesService
  ): Promise<ImmoIPImmoTaskChangesObject> {
    let toReturn = await immoIPImmoTaskChangesService.getObject(immoTask.id);

    if (
      toReturn != null &&
      immoTask.tourItem != null &&
      immoTask.tourItem.id != null &&
      toReturn.tourItemId !== immoTask.tourItem.id
    ) {
      await immoIPImmoTaskChangesService.removeObject(toReturn);
      toReturn = null;
    }

    if (toReturn == null) {
      toReturn = {
        id: immoTask.id,
        tourItemId: immoTask.tourItem == null ? null : immoTask.tourItem.id,
        executionFeedback: immoTask.executionFeedback,
        executionStarted: false
      };
    }

    return toReturn;
  }

  public static getExecutionAssets(
    immoTask: ImmoTask,
    immoIPPlacerImmoTaskChangeStorageHandler: ImmoIPPlacerImmoTaskChangeStorageHandler
  ): Asset[] {
    const onlineAssets = !CollectionHelper.isPopulated(immoTask.assets)
      ? []
      : immoTask.assets.map(a =>
          a.asset != null &&
          a.type != null &&
          a.type.ordinal === IMMO_TASK_ASSET_TYPE_CHOICES.EXECUTION.ordinal
            ? a.asset
            : null
        );
    if (onlineAssets.length > 0) {
      CollectionHelper.filterInPlace(onlineAssets, a => a != null);
    }

    let offlineAssets =
      immoIPPlacerImmoTaskChangeStorageHandler.currentImmoIPTaskChangesObject
        .offlineAssets;
    const toDeleteAssetUuids =
      immoIPPlacerImmoTaskChangeStorageHandler.currentImmoIPTaskChangesObject
        .toDeleteAssetUuids;
    if (!CollectionHelper.isPopulated(offlineAssets)) {
      return onlineAssets;
    }

    offlineAssets = offlineAssets.map(oa => clone(oa));

    // prefer showing offline assets
    if (onlineAssets.length > 0) {
      CollectionHelper.filterInPlace(
        onlineAssets,
        onlineAsset =>
          offlineAssets.findIndex(
            offlineAsset => offlineAsset.uuid === onlineAsset.uuid
          ) < 0 &&
          (!CollectionHelper.isPopulated(toDeleteAssetUuids) ||
            toDeleteAssetUuids.findIndex(uuid => onlineAsset.uuid === uuid) < 0)
      );
    }

    return onlineAssets.concat(offlineAssets);
  }

  public static async reloadOfflineChangeObject(
    immoTask: ImmoTask,
    immoIPImmoTaskChangesService: ImmoIPImmoTaskChangesService,
    immoIPPlacerImmoTaskChangeStorageHandler: ImmoIPPlacerImmoTaskChangeStorageHandler
  ): Promise<void> {
    const reloadedImmoTaskChanges = await this.initializeImmoTaskChanges(
      immoTask,
      immoIPImmoTaskChangesService
    );
    immoIPPlacerImmoTaskChangeStorageHandler.currentImmoIPTaskChangesObject = reloadedImmoTaskChanges;
  }
}
